import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { translatePackages } from './domain/common/utilities/translate-packages.utility';
import { reportWebVitals } from './report-web-vitals';
import './styles/global.module.css';

translatePackages();

(async () => {
  const { Main } = await import('./components/main');
  ReactDOM.render(
    <StrictMode>
      <Main />
    </StrictMode>,
    document.getElementById('root'),
  );
})();

reportWebVitals();
